export type DiscoveryPreferences = {
  genreIds: number[];
  providerIds: number[];
  minimumRating: string;
  releasedFrom: string;
  releasedBefore: string;
};

export const defaultDiscoveryPreferences = (): DiscoveryPreferences => ({ genreIds: [], providerIds: [], minimumRating: "", releasedFrom: "", releasedBefore: "" });

export const providerOptions = [
  { value: 8, label: "Netflix" }, { value: 9, label: "Prime Video" },
  { value: 337, label: "Disney+" }, { value: 39, label: "NOW" },
  { value: 350, label: "Apple TV+" }, { value: 531, label: "Paramount+" },
  { value: 103, label: "Channel 4" },
];

export const genreOptions = [
  { value: 28, label: "Action" }, { value: 12, label: "Adventure" },
  { value: 16, label: "Animation" }, { value: 35, label: "Comedy" },
  { value: 80, label: "Crime" }, { value: 99, label: "Documentary" },
  { value: 18, label: "Drama" }, { value: 10751, label: "Family" },
  { value: 14, label: "Fantasy" }, { value: 36, label: "History" },
  { value: 27, label: "Horror" }, { value: 10402, label: "Music" },
  { value: 9648, label: "Mystery" }, { value: 10749, label: "Romance" },
  { value: 878, label: "Sci-fi" }, { value: 10770, label: "TV Movie" },
  { value: 53, label: "Thriller" }, { value: 10752, label: "War" },
  { value: 37, label: "Western" },
];
